"use strict";
/**
 * Canonical plan-key catalogue for the checkout / upgrade flow (SM-325).
 *
 * This module is the single source of truth for the FE-facing plan keys:
 * the `CheckoutPlan` / `PlanKey` types are derived from the runtime tuples
 * below, and consumers (e.g. the web app) import the tuples to build their own
 * validation allow-lists instead of re-declaring the literal list. A rename or
 * a new plan is now a one-line edit here.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAN_KEYS = exports.CHECKOUT_PLANS = void 0;
/**
 * Every checkoutable plan key, in catalogue order. Each maps 1:1 to a Stripe
 * product bundle. Excludes the free `basis` tier, which is not checkoutable.
 */
exports.CHECKOUT_PLANS = ['pro', 'courseOnly', 'aiOnly', 'fullAccess'];
/**
 * Every plan key including the free `basis` tier. The upgrade flow uses this
 * superset of `CHECKOUT_PLANS` to describe both a user's current and target
 * plans (`basis` is a valid *current* plan but never a valid upgrade target).
 */
exports.PLAN_KEYS = ['basis', ...exports.CHECKOUT_PLANS];
